import i18n from '@hapana/shared/web/i18n'

export const ROUTES = {
  dashboard: {
    path: '',
    title: i18n.t('core:dashboard.title'),
    resourcePath: 'home',
  },
  home2: {
    path: 'home-2',
    title: i18n.t('core:routes.home2'),
    resourcePath: 'home-2',
  },
  login: {
    path: 'login',
  },
  logout: {
    path: 'logout',
  },
  loginAs: {
    path: 'login-as',
  },
  locationSelection: {
    path: '/location-selection',
    title: i18n.t('core:locationSelection.title'),
    resourcePath: 'location-selection',
  },
  locationSettingsRedirect: {
    path: 'location-settings',
    redirectTo: 'settings',
  },
  controlCenter: {
    path: 'control-hub',
    title: i18n.t('core:controlCenter.title'),
    resourcePath: 'control-hub',
    children: {
      communicationTemplates: {
        path: 'control-hub/communication-templates',
        title: i18n.t('core:controlCenter.communicationTemplates.cardTitle'),
        resourcePath: 'communication-templates',
      },
      faqs: {
        path: 'control-hub/faqs',
        title: i18n.t('core:controlCenter.faqs.cardTitle'),
        resourcePath: 'faqs',
      },
      planAndAddons: {
        path: 'control-center/plan-and-addons',
        title: i18n.t('core:controlCenter.planAndAddons.cardTitle'),
        resourcePath: 'plan-and-addons',
        children: {
          comparePlans: {
            path: 'control-center/plan-and-addons/compare',
            title: i18n.t('core:controlCenter.planAndAddons.comparePlans'),
            // Deliberately the full segment pair: useBreadcrumbs matches resourcePath as a
            // substring of the pathname, so a bare 'compare' would light up on unrelated routes.
            resourcePath: 'plan-and-addons/compare',
          },
        },
      },
      integrations: {
        path: 'control-hub/integrations',
        title: i18n.t('core:controlCenter.integrations.cardTitle'),
        resourcePath: 'integrations',
      },
      apiIntegrations: {
        path: 'control-center/developer-apis',
        title: i18n.t('core:controlCenter.apiIntegrations.cardTitle'),
        resourcePath: 'developer-apis',
        children: {
          apiIntegrationsTabs: {
            path: 'control-center/developer-apis/:tab',
            resourcePath: 'developer-apis',
            title: i18n.t('core:controlCenter.apiIntegrations.cardTitle'),
          },
          // Bookmarks and links from before the page was renamed (INT-1412).
          legacyApiIntegrations: {
            path: 'control-center/api-integrations',
            resourcePath: 'api-integrations',
            title: i18n.t('core:controlCenter.apiIntegrations.cardTitle'),
          },
          legacyApiIntegrationsTabs: {
            path: 'control-center/api-integrations/:tab',
            resourcePath: 'api-integrations',
            title: i18n.t('core:controlCenter.apiIntegrations.cardTitle'),
          },
        },
      },
      marketplace: {
        path: 'control-center/marketplace',
        title: i18n.t('core:controlCenter.marketplace.cardTitle'),
        resourcePath: 'marketplace',
        children: {
          providerDetail: {
            // Optional :tab segment (connection | mapping | history) so each tab
            // is deep-linkable; absent = default to the connection tab.
            path: 'control-center/marketplace/:providerId/:tab?',
            resourcePath: 'marketplace',
            title: i18n.t('core:controlCenter.marketplace.cardTitle'),
          },
        },
      },
      scheduler: {
        path: 'control-hub/scheduler',
        title: i18n.t('core:controlCenter.schedule.cardTitle'),
        resourcePath: 'control-hub/scheduler',
        children: {
          schedulerTabs: {
            path: 'control-hub/scheduler/:tab',
            title: i18n.t('core:controlCenter.schedule.cardTitle'),
            resourcePath: 'control-hub/scheduler',
          },
          sessionGroups: {
            path: 'control-hub/scheduler/session-groups',
            title: i18n.t('core:controlCenter.schedule.tabs.sessionGroups'),
            resourcePath: 'control-hub/scheduler/session-groups',
          },
          newSessionGroup: {
            path: 'control-hub/scheduler/session-groups/new',
            title: i18n.t('core:controlCenter.schedule.sessionGroups.form.newTitle'),
            resourcePath: 'control-hub/scheduler/session-groups/new',
          },
          editSessionGroup: {
            path: 'control-hub/scheduler/session-groups/:corporateSessionTypeId',
            title: i18n.t('core:controlCenter.schedule.sessionGroups.form.editTitle'),
            resourcePath: 'control-hub/scheduler/session-groups',
          },
        },
      },
      retailSalesSettings: {
        path: 'control-hub/retail-settings',
        title: i18n.t('core:controlCenter.retailSettings.cardTitle'),
        resourcePath: 'retail-settings',
      },
      retailGeneralSettings: {
        path: 'control-hub/retail-settings/general',
        title: i18n.t('core:controlCenter.retailGeneralSettings.cardTitle'),
        resourcePath: 'control-hub/retail-settings/general',
        children: {
          retailGeneralSettingsTabs: {
            path: 'control-hub/retail-settings/general/:tab',
            resourcePath: 'control-hub/retail-settings/general',
            title: i18n.t('core:controlCenter.retailGeneralSettings.cardTitle'),
          },
        },
      },
      brandCustomization: {
        path: 'control-hub/brand-customization',
        title: i18n.t('core:controlCenter.brandCustomization.cardTitle'),
        resourcePath: 'brand-customization',
      },
      auditHistory: {
        path: 'control-hub/audit-history',
        title: i18n.t('core:controlCenter.auditHistory.cardTitle'),
        resourcePath: 'audit-history',
      },
      onboarding: {
        path: 'control-center/migration',
        title: i18n.t('core:controlCenter.onboarding.cardTitle'),
        resourcePath: 'migration',
        children: {
          migrationWizard: {
            path: 'control-center/migration/:migrationId',
            title: i18n.t('core:controlCenter.onboarding.wizardTitle'),
            resourcePath: 'migration',
          },
        },
      },
      selfService: {
        path: 'control-hub/self-service',
        title: i18n.t('core:controlCenter.selfService.cardTitle'),
        resourcePath: 'self-service',
      },
      commissions: {
        path: 'control-hub/commissions',
        title: i18n.t('core:controlCenter.commissions.cardTitle'),
        resourcePath: 'commissions',
      },
      security: {
        path: 'control-hub/security',
        title: i18n.t('core:controlCenter.security.cardTitle'),
        resourcePath: 'control-hub/security',
        children: {
          securityTabs: {
            path: 'control-hub/security/:tab',
            resourcePath: 'control-hub/security',
            title: i18n.t('core:controlCenter.security.cardTitle'),
          },
        },
      },
      memberMovement: {
        path: 'control-center/member-movement',
        title: i18n.t('core:controlCenter.memberMovement.cardTitle'),
        resourcePath: 'member-movement',
        children: {
          memberMovementTabs: {
            path: 'control-center/member-movement/:tab',
            resourcePath: 'member-movement',
            title: i18n.t('core:controlCenter.memberMovement.cardTitle'),
          },
          memberMovementRunDetail: {
            path: 'control-center/member-movement/runs/:runId',
            resourcePath: 'member-movement',
            title: i18n.t('core:controlCenter.memberMovement.cardTitle'),
          },
        },
      },
      classCovers: {
        path: 'control-hub/class-covers',
        title: i18n.t('core:controlCenter.classCovers.cardTitle'),
        resourcePath: 'control-hub/class-covers',
      },
      familySettings: {
        path: 'control-hub/family-accounts',
        title: i18n.t('core:controlCenter.familySettings.cardTitle'),
        resourcePath: 'control-hub/family-accounts',
      },
      memberExperiences: {
        path: 'control-hub/member-experiences',
        title: i18n.t('core:controlCenter.memberExperiences.pageTitle'),
        resourcePath: 'control-hub/member-experiences',
        children: {
          generalSettings: {
            path: 'control-hub/member-experiences/settings',
            title: i18n.t('core:setup.tabs.general', 'Settings'),
            resourcePath: 'control-hub/member-experiences/settings',
          },
          deeplinks: {
            path: 'control-hub/member-experiences/deeplinks',
            title: i18n.t('core:setup.tabs.deeplinks', 'Deeplinks'),
            resourcePath: 'control-hub/member-experiences/deeplinks',
          },
          mobileApp: {
            path: 'control-hub/member-experiences/mobile-app',
            title: i18n.t('core:setup.tabs.mobileApp', 'Mobile App'),
            resourcePath: 'control-hub/member-experiences/mobile-app',
          },
          embed: {
            path: 'control-hub/member-experiences/embed',
            title: i18n.t('core:setup.tabs.embed', 'Embed'),
            resourcePath: 'control-hub/member-experiences/embed',
          },
          kiosk: {
            path: 'control-hub/member-experiences/kiosk',
            title: i18n.t('core:setup.tabs.kiosk', 'Kiosk'),
            resourcePath: 'control-hub/member-experiences/kiosk',
          },
        },
      },
    },
  },
  product: {
    path: 'product',
    title: i18n.t('core:routes.product'),
    resourcePath: 'product',
    children: {
      eventTracker: {
        path: 'product/event-tracker',
        title: i18n.t('core:routes.eventTracker'),
        resourcePath: 'event-tracker',
      },
      dynamicLoaderDemo: {
        path: 'product/dynamic-loader-demo',
        title: i18n.t('core:routes.dynamicLoaderDemo'),
        resourcePath: 'dynamic-loader-demo',
      },
    },
  },
  notFound: {
    path: '*',
  },
  userProfile: {
    path: 'profile',
    title: i18n.t('core:routes.profile'),
    resourcePath: 'profile',
  },
  clients: {
    path: 'clients',
    pathWithSlash: '/clients',
    title: i18n.t('core:routes.clients'),
    resourcePath: 'clients',
    children: {
      clientOverview: {
        path: 'clients/:clientId',
        pathWithSlash: '/clients',
        title: i18n.t('core:routes.clientOverview'),
        resourcePath: 'client-overview',
      },
    },
  },
  siteTeamAccess: {
    path: 'team-access',
    title: i18n.t('core:routes.teamAccess'),
    resourcePath: 'team-access',
  },
  userAccess: {
    path: 'user-access',
    title: i18n.t('core:routes.userAccess'),
    resourcePath: 'user-access',
    children: {
      userAccessTabs: {
        path: 'user-access/:tab',
        resourcePath: 'user-access',
      },
    },
  },
  retail: {
    path: 'retail',
    title: i18n.t('core:retailDashboard.title'),
    resourcePath: 'retail',
  },
  settings: {
    path: 'settings',
    title: i18n.t('core:settings.title'),
    resourcePath: 'settings',
    children: {
      locationSettings: {
        path: 'settings/location-settings',
        title: i18n.t('core:settings.systemSettings.locationSettings.title'),
        resourcePath: 'location-settings',
        children: {
          locationSettingsTabs: {
            path: 'settings/location-settings/:tab',
            resourcePath: 'location-settings',
            title: i18n.t('core:settings.systemSettings.locationSettings.title'),
          },
          roomResourceConfiguration: {
            path: 'settings/location-settings/room-resource-configuration',
            title: i18n.t(
              'core:settings.systemSettings.locationSettings.configuration.roomResourceConfiguration'
            ),
            resourcePath: 'room-resource-configuration',
          },
          siteCommunicationTemplates: {
            path: 'settings/location-settings/site-communication-templates',
            title: i18n.t(
              'core:settings.systemSettings.locationSettings.siteCommunicationTemplates'
            ),
            resourcePath: 'site-communication-templates',
          },
        },
      },
      schedulerSettings: {
        path: 'settings/scheduler-settings',
        title: i18n.t('core:settings.scheduler.title'),
        resourcePath: 'scheduler-settings',
        children: {
          schedulerSettingsTabs: {
            path: 'settings/scheduler-settings/:tab',
            resourcePath: 'scheduler-settings',
            title: i18n.t('core:settings.systemSettings.schedulerSettings.title'),
          },
        },
      },
      retailSettings: {
        path: 'settings/retail-settings',
        title: i18n.t('core:settings.retail.title'),
        resourcePath: 'retail-settings',
        children: {
          retailSettingsTabs: {
            path: 'settings/retail-settings/:tab',
            resourcePath: 'retail-settings',
            title: i18n.t('core:settings.retail.title'),
          },
        },
      },
      accountSettings: {
        path: 'settings/account-settings',
        title: i18n.t('core:settings.account.title'),
        resourcePath: 'account-settings',
        children: {
          accountSettingsTabs: {
            path: 'settings/account-settings/:tab',
            resourcePath: 'account-settings',
            title: i18n.t('core:settings.account.title'),
          },
        },
      },
      wellnessSettings: {
        path: 'settings/wellness-settings',
        title: i18n.t('core:settings.cards.wellness.cardTitle'),
        resourcePath: 'wellness-settings',
        children: {
          wellnessSettingsTabs: {
            path: 'settings/wellness-settings/:tab',
            resourcePath: 'wellness-settings',
            title: i18n.t('core:settings.cards.wellness.cardTitle'),
          },
        },
      },
      // OC-759: location-level Audit History is hidden until the log is reworked. Restore this
      // alongside the card in settings.constants.js and the route in router.jsx. Brand-level
      // Audit History lives at ROUTES.controlCenter.children.auditHistory and is unaffected.
      // auditHistorySettings: {
      //   path: 'settings/audit-history',
      //   title: i18n.t('core:controlCenter.auditHistory.cardTitle'),
      //   resourcePath: 'settings-audit-history',
      // },
    },
  },

  capital: {
    path: 'capital',
    title: i18n.t('core:routes.capital'),
    resourcePath: 'capital',
  },

  covers: {
    path: 'covers',
    title: i18n.t('core:routes.covers'),
    resourcePath: '/covers',
    children: {
      queue: {
        path: 'covers/queue',
        title: i18n.t('core:routes.coverQueue'),
        resourcePath: '/covers/queue',
      },
    },
  },

  coverClaim: {
    path: 'p/cover-claim/:token',
  },

  publicFormFill: {
    path: 'p/form/:token',
  },

  assistant: {
    path: 'assistant',
    title: i18n.t('core:routes.assistant'),
    resourcePath: 'assistant',
    children: {
      search: {
        path: 'assistant/search',
        title: i18n.t('core:routes.assistantSearch'),
        resourcePath: 'assistant-search',
      },
      chats: {
        path: 'assistant/chats',
        title: i18n.t('core:routes.assistantChats'),
        resourcePath: 'assistant-chats',
      },
      support: {
        path: 'assistant/support',
        title: i18n.t('core:routes.assistantSupport'),
        resourcePath: 'assistant-support',
      },
      docs: {
        path: 'assistant/docs',
        title: i18n.t('core:routes.assistantDocs'),
        resourcePath: 'assistant-docs',
      },
      activity: {
        path: 'assistant/activity',
        title: i18n.t('core:routes.assistantActivity'),
        resourcePath: 'assistant-activity',
      },
    },
  },
  updates: {
    path: 'updates',
    title: i18n.t('core:releaseHub.title'),
    resourcePath: 'updates',
    children: {
      helpDocs: {
        path: 'updates/help-docs',
        title: i18n.t('core:releaseHub.tabs.helpDocs'),
        resourcePath: 'updates-help-docs',
      },
      helpDoc: {
        path: 'updates/help-docs/:slug',
        title: i18n.t('core:releaseHub.tabs.helpDocs'),
        resourcePath: 'updates-help-doc',
      },
      note: {
        path: 'updates/:slug',
        title: i18n.t('core:releaseHub.tabs.whatsNew'),
        resourcePath: 'updates-note',
      },
    },
  },
  helpDocs: {
    path: 'help-docs',
    title: i18n.t('core:helpDocs.title'),
    resourcePath: 'help-docs',
    children: {
      article: {
        path: 'help-docs/:slug',
        title: i18n.t('core:helpDocs.articleTitle'),
        resourcePath: 'help-docs-article',
      },
    },
  },
  mobileSetup: {
    path: 'mobile-setup',
    title: i18n.t('common:navigationLinks.mobileSetup', 'Mobile Setup'),
    resourcePath: 'mobile-setup',
  },

  schedule: {
    path: 'schedule',
    title: i18n.t('core:routes.schedule'),
    resourcePath: 'schedule',
  },
  payments: {
    path: 'payments',
    title: i18n.t('core:routes.payments'),
    resourcePath: 'payments',
  },
  reports: {
    path: 'reports',
    title: i18n.t('core:routes.reports'),
    resourcePath: 'reports',
    children: {
      reportsTabs: {
        path: 'reports/:tab',
        title: i18n.t('core:routes.reports'),
        resourcePath: 'reports',
      },
    },
  },
  memberView: {
    path: 'member-view',
    title: 'Member View',
    resourcePath: 'member-view',
  },
  retailDashboard: {
    path: 'retail',
    title: i18n.t('core:retailDashboard.title', 'Retail Dashboard'),
    resourcePath: 'retail',
    children: {
      paymentLog: {
        path: 'retail/payment-log',
        title: i18n.t('core:retailDashboard.paymentLog.title', 'Payment Log'),
        resourcePath: 'payment-log',
      },
      memberships: {
        path: 'retail/memberships',
        title: i18n.t('core:retailDashboard.memberships.title', 'Memberships'),
        resourcePath: 'memberships',
      },
      scheduled: {
        path: 'retail/scheduled',
        title: i18n.t('core:retailDashboard.scheduled.title', 'Scheduled'),
        resourcePath: 'scheduled',
      },
      pos: {
        path: 'retail/pos',
        title: i18n.t('core:retailDashboard.pos.title', 'POS'),
        resourcePath: 'pos',
      },
      giftCard: {
        path: 'retail/gift-card',
        title: i18n.t('core:retailDashboard.giftCard.title', 'Gift Card'),
        resourcePath: 'gift-card',
      },
      failed: {
        path: 'retail/failed',
        title: i18n.t('core:retailDashboard.failed.title', 'Failed Payments'),
        resourcePath: 'failed',
      },
      cancelledInvoices: {
        path: 'retail/cancelled-invoices',
        title: i18n.t('core:retailDashboard.cancelledInvoices.title'),
        resourcePath: 'cancelled-invoices',
      },
      draftInvoices: {
        path: 'retail/draft-invoices',
        title: i18n.t('core:retailDashboard.draftInvoices.title', 'Draft Invoices'),
        resourcePath: 'draft-invoices',
      },
      payAsYouGo: {
        path: 'retail/pay-as-you-go',
        title: i18n.t('core:retailDashboard.payAsYouGo.title', 'Pay As You Go'),
        resourcePath: 'pay-as-you-go',
      },
      cashDrawer: {
        path: 'retail/cash-drawer',
        title: i18n.t('core:retailDashboard.cashDrawer.title'),
        resourcePath: 'cash-drawer',
      },
      newSale: {
        path: 'retail/new-sale',
        resourcePath: 'new-sale',
        title: i18n.t('core:routes.newSale'),
        children: {
          newSaleTabs: {
            path: 'retail/new-sale/:tab',
            resourcePath: 'new-sale',
            title: i18n.t('core:routes.newSale'),
          },
        },
      },
      checkout: {
        path: 'retail/checkout',
        resourcePath: 'checkout',
        title: i18n.t('core:routes.checkout'),
      },
      paymentDetail: {
        path: 'retail/invoice/:invoiceId',
        resourcePath: 'payment-detail',
        title: i18n.t('core:retailDashboard.paymentDetail.title', 'Payment Details'),
      },
      invoice: {
        path: 'retail/invoice/:invoiceId/invoice',
        resourcePath: 'invoice',
        title: i18n.t('core:retailDashboard.invoice.title', 'Invoice'),
      },
      recurringPaymentDetail: {
        path: 'retail/recurring-payment/:serviceId',
        resourcePath: 'recurring-payment-detail',
        title: i18n.t(
          'core:retailDashboard.recurringPaymentDetail.title',
          'Recurring Payment Detail'
        ),
      },
    },
  },
  contentSuite: {
    path: 'content-suite',
    title: i18n.t('core:contentSuite.listing.title', 'Content Suite'),
    resourcePath: 'content-suite',
    children: {
      contentEntry: {
        path: 'content-suite/:entryId',
        title: i18n.t('core:contentSuite.listing.title', 'Content Suite'),
        resourcePath: 'content-suite-entry',
      },
      mediaLibrary: {
        path: 'content-suite/media',
        title: i18n.t('core:contentSuite.listing.tabs.mediaLibrary', 'Media Library'),
        resourcePath: 'content-suite-media',
      },
      analytics: {
        path: 'content-suite/analytics',
        title: i18n.t('core:contentSuite.listing.tabs.analytics', 'Analytics'),
        resourcePath: 'content-suite-analytics',
      },
    },
  },
  accessDenied: {
    path: 'access-denied',
  },
  requireAuth: {
    path: '',
  },
  zapierConnect: {
    path: 'zapier/connect',
  },
  upgrade: {
    path: 'upgrade',
    title: 'Plans',
    resourcePath: 'upgrade',
  },
}
export const SETTINGS_ROUTES_PATH = [
  ROUTES.settings,
  ROUTES.settings.children.locationSettings,
  ROUTES.settings.children.locationSettings.children.locationSettingsTabs,
  ROUTES.settings.children.locationSettings.children.roomResourceConfiguration,
  ROUTES.settings.children.locationSettings.children.siteCommunicationTemplates,
  ROUTES.settings.children.schedulerSettings,
  ROUTES.settings.children.retailSettings,
  ROUTES.settings.children.retailSettings.children.retailSettingsTabs,
  ROUTES.settings.children.accountSettings,
  ROUTES.settings.children.accountSettings.children.accountSettingsTabs,
]

export const PROTECTED_ROUTES_PATHS = [
  ROUTES.dashboard,
  ROUTES.userProfile,
  ROUTES.userAccess,
  ROUTES.userAccess.children.userAccessTabs,
  ROUTES.siteTeamAccess,
  ROUTES.schedule,
  ROUTES.covers,
  ROUTES.covers.children.queue,
  ROUTES.payments,
  ROUTES.reports,
  ROUTES.memberView,
  ROUTES.reports.children.reportsTabs,
  ROUTES.settings,
  ROUTES.settings.children.locationSettings,
  ROUTES.settings.children.locationSettings.children.locationSettingsTabs,
  ROUTES.settings.children.locationSettings.children.roomResourceConfiguration,
  ROUTES.settings.children.locationSettings.children.siteCommunicationTemplates,
  ROUTES.settings.children.schedulerSettings,
  ROUTES.settings.children.retailSettings,
  ROUTES.settings.children.retailSettings.children.retailSettingsTabs,
  ROUTES.settings.children.accountSettings,
  ROUTES.settings.children.accountSettings.children.accountSettingsTabs,
  ROUTES.controlCenter,
  ROUTES.controlCenter.children.faqs,
  ROUTES.controlCenter.children.integrations,
  ROUTES.controlCenter.children.apiIntegrations,
  ROUTES.controlCenter.children.apiIntegrations.children.apiIntegrationsTabs,
  ROUTES.controlCenter.children.marketplace,
  ROUTES.controlCenter.children.marketplace.children.providerDetail,
  ROUTES.controlCenter.children.communicationTemplates,
  ROUTES.controlCenter.children.planAndAddons,
  ROUTES.controlCenter.children.planAndAddons.children.comparePlans,
  ROUTES.controlCenter.children.auditHistory,
  ROUTES.controlCenter.children.scheduler,
  ROUTES.controlCenter.children.scheduler.children.sessionGroups,
  ROUTES.controlCenter.children.retailGeneralSettings,
  ROUTES.controlCenter.children.retailGeneralSettings.children.retailGeneralSettingsTabs,
  ROUTES.controlCenter.children.onboarding,
  ROUTES.controlCenter.children.onboarding.children.migrationWizard,
  ROUTES.controlCenter.children.selfService,
  ROUTES.controlCenter.children.commissions,
  ROUTES.controlCenter.children.security,
  ROUTES.controlCenter.children.security.children.securityTabs,
  ROUTES.controlCenter.children.memberMovement,
  ROUTES.controlCenter.children.memberMovement.children.memberMovementTabs,
  ROUTES.controlCenter.children.memberMovement.children.memberMovementRunDetail,
  ROUTES.controlCenter.children.classCovers,
  ROUTES.controlCenter.children.familySettings,
  ROUTES.controlCenter.children.memberExperiences,
  ROUTES.controlCenter.children.memberExperiences.children.generalSettings,
  ROUTES.controlCenter.children.memberExperiences.children.deeplinks,
  ROUTES.controlCenter.children.memberExperiences.children.mobileApp,
  ROUTES.controlCenter.children.memberExperiences.children.embed,
  ROUTES.controlCenter.children.memberExperiences.children.kiosk,
  ROUTES.product,
  ROUTES.product.children.eventTracker,
  ROUTES.product.children.dynamicLoaderDemo,
  ROUTES.retailDashboard.children.newSale,
  ROUTES.retailDashboard.children.newSale.children.newSaleTabs,
  ROUTES.retailDashboard.children.checkout,
  ROUTES.helpDocs,
  ROUTES.helpDocs.children.article,
  ROUTES.contentSuite,
  ROUTES.contentSuite.children.contentEntry,
  ROUTES.contentSuite.children.mediaLibrary,
  ROUTES.assistant,
  ROUTES.assistant.children.search,
  ROUTES.assistant.children.chats,
  ROUTES.assistant.children.support,
  ROUTES.assistant.children.docs,
  ROUTES.assistant.children.activity,
  ROUTES.upgrade,
]
